import { PayloadAction } from '@reduxjs/toolkit';
import { selectIntpWebsite, selectStpRates } from '@va/aaas/shared/selectors';
import { IntpWebsite, StpCounterResponse } from '@va/aaas/shared/types';
import { all, call, delay, select } from 'redux-saga/effects';
import { fetchExternalSubscriptionSaga } from './billingSaga';
import { onRequestIntpWebsite, onRequestStpRates } from './rootSaga';

/**
 * For INTPs that use platform billing
 * We need to update the STP limit and the internal 3as subscription attached to the website
 */
export function* syncAppStateAfterSubscriptionUpgrade(action: PayloadAction<{ newPackageId: string }>) {
  const { newPackageId } = action.payload;

  yield all([
    call(fetchExternalSubscriptionSaga),
    call(syncStpRatesAfterSubscriptionUpgrade, { newPackageId }),
    call(syncIntpWebsiteAfterSubscriptionUpgrade, { newPackageId }),
  ]);
}

function* syncIntpWebsiteAfterSubscriptionUpgrade({ newPackageId }: { newPackageId: string }) {
  let retryCount = 0;
  const delayStep = 500;
  const maxRetryCount = 20;

  while (retryCount <= maxRetryCount) {
    yield delay(delayStep * (retryCount + 1));

    try {
      yield call(onRequestIntpWebsite);
      const intpWebsite: IntpWebsite = yield select(selectIntpWebsite);

      if (intpWebsite.packageId === newPackageId) {
        break;
      }
    } catch (error) {
      console.error('Could not fetch intp website', error);
    }

    retryCount++;
  }
}

function* syncStpRatesAfterSubscriptionUpgrade({ newPackageId }: { newPackageId: string }) {
  let retryCount = 0;
  const delayStep = 500;
  const maxRetryCount = 20;

  while (retryCount <= maxRetryCount) {
    yield delay(delayStep * (retryCount + 1));

    try {
      yield call(onRequestStpRates);
      const stpRates: StpCounterResponse = yield select(selectStpRates);

      if (stpRates.packageId === newPackageId) {
        break;
      }
    } catch (error) {
      console.error('Could not fetch stp rates:', error);
    }

    retryCount++;
  }
}
